import React, {useEffect} from 'react';
import YouTube from 'react-youtube';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const Video = () => {
    gsap.registerPlugin(ScrollTrigger);
    useEffect(() => {
        gsap.from('.h1video', {y: 50, opacity: 0, duration: 1, scrollTrigger: '.video'})
        gsap.from('.videoDiv', {y: 30, opacity: 0, duration: 1, scrollTrigger: '.video', delay: 0.5, scale: 0.8})
    }, [])
    const opts = {
        width: '100%',
        height: '600px'
    }
    return(
        <div className='video'>
            <h1 className='h1Large h1video'>Zapraszamy do obejrzenia!</h1>
            <div className='videoDiv'>
                <YouTube className='videoPlayer' videoId='jOmsv_bworc' opts={opts}  />
            </div>
        </div>
    )
}
export default Video;